// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5g-2";
export var blackBorderOnHover = "_5g-7";
export var cell = "_5g-6";
export var cellContainer = "_5g-3";
export var checked = "_5g-8";
export var disabled = "_5g-5";
export var featuredIconCellContainer = "_5g-9";
export var featuredIconTextContainer = "_5g-b";
export var featuredIconWrapper = "_5g-a";
export var noBorder = "_5g-c";
export var orangeSelectedRow = "_ck-3";
export var overflowableText = "_5g-0";
export var overflowableTextContainer = "_5g-1";
export var row = "_5h-0";
export var rowCheckboxCell = "_5g-4";
export var selectableTable = "_ck-2";